module.exports = __webpack_public_path__ + "resources/1px-467b7e4156b94a53755863266da11444.png";